import React from 'react';

// VPN guard removed for simplicity.
export const VPNGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => <>{children}</>;
